import { api } from './api';
import { grundHeader } from '../components/ui/loeschen-mit-grund-dialog';

export type PersonListVisibility = 'private' | 'public';

export interface PersonListOwner {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
}

export interface PersonListItem {
  id: number;
  name: string;
  description?: string | null;
  visibility: PersonListVisibility;
  created_by_user_id: number;
  standort_id?: number | null;
  created_at: string;
  updated_at: string;
  owner: PersonListOwner;
  member_count?: number | null;
  can_edit: boolean;
}

export interface PersonListMember {
  id: number;
  list_id: number;
  wp_user_id: number;
  sub_index?: number | null;
  added_by_user_id?: number | null;
  created_at: string;
  display_name?: string | null;
  user_email?: string | null;
}

export const personListsApi = {
  list: async (params?: { scope?: 'mine' | 'public' | 'all'; standortId?: number }): Promise<PersonListItem[]> => {
    const search = new URLSearchParams();
    if (params?.scope) search.set('scope', params.scope);
    if (params?.standortId && params.standortId > 0) search.set('standort_id', String(params.standortId));
    const query = search.toString();
    const url = query ? `/api/person-lists?${query}` : '/api/person-lists';
    const res = await api.get<{ items: PersonListItem[] }>(url);
    return res.items || [];
  },

  create: async (payload: {
    name: string;
    description?: string;
    visibility: PersonListVisibility;
    standort_id?: number | null;
  }): Promise<PersonListItem> => {
    return api.post<PersonListItem>('/api/person-lists', payload);
  },

  update: async (
    id: number,
    payload: Partial<{ name: string; description: string | null; visibility: PersonListVisibility; standort_id: number | null }>,
  ): Promise<PersonListItem> => {
    return api.put<PersonListItem>(`/api/person-lists/${id}`, payload);
  },

  delete: async (id: number, grund: string): Promise<void> => {
    await api.delete(`/api/person-lists/${id}`, grundHeader(grund));
  },

  getMembers: async (id: number): Promise<PersonListMember[]> => {
    const res = await api.get<{ items: PersonListMember[] }>(`/api/person-lists/${id}/members`);
    return res.items || [];
  },

  addMembers: async (
    id: number,
    members: Array<{ wp_user_id: number; sub_index?: number | null }>,
  ): Promise<PersonListMember[]> => {
    const res = await api.post<{ items: PersonListMember[] }>(`/api/person-lists/${id}/members`, { members });
    return res.items || [];
  },

  removeMember: async (id: number, memberId: number): Promise<void> => {
    await api.delete(`/api/person-lists/${id}/members/${memberId}`);
  },
};
